import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class JwtExpirationCheckerService {
  constructor() {}

  checkTokenExpiration(): string {
    const token = localStorage.getItem('auth0Token');

    if (!token) {
      console.log('No token found in localStorage.');
      return 'no_token';
    }

    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      console.log('Invalid JWT token format.');
      return 'invalid_token';
    }

    try {
      const payload = JSON.parse(atob(tokenParts[1]));
      console.log(payload);
      const exp = payload.exp;

      if (!exp) {
        console.log('Token does not have an expiration field.');
        return 'invalid_token';
      }

      const expirationDate = new Date(exp * 1000); // exp is in seconds
      const currentDate = new Date();

      if (currentDate >= expirationDate) {
        console.log(`Token expired at ${expirationDate.toISOString()}`);
        return 'invalid_token';
      } else {
        console.log(
          `Token is valid. It will expire at ${expirationDate.toISOString()}`,
        );
        return 'valid_token';
      }
    } catch (error) {
      console.log('Error parsing the token payload:', error);
      return 'token_parsing_error';
    }
  }
}
